import H from 'history'

interface isCurrentOptions {
    exact?: boolean
}

export function isExternalLink(to: string, rel?: string) {
    return to.indexOf('//') === 0 || to.indexOf('http') === 0 || rel === 'external'
}

export function isNonHttpLink(to: string) {
    return to.indexOf('mailto:') === 0 || to.indexOf('tel:') === 0
}

export function isAnchorLink(to: string) {
    return to.charAt(0) === '#'
}

export function isCurrent(location: H.Location, link: string, opts?: isCurrentOptions) {
    if (opts && opts.exact) {
        return location.pathname === link
    }

    return location.pathname.indexOf(link) === 0
}
